import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {
  WebPageActiveTable,
  WebPageCompletedTable,
} from './WebPageCommunicationTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const WebPageTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});
  const tabs = {
    active: {
      label: 'Active',
      view: <WebPageActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <WebPageCompletedTable searchValue={searchValue} />,
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
